import { defineComponent as _defineComponent } from 'vue'
import OzContainedButton, {
  OzContainedButtonColorScheme,
  OzContainedButtonSizePreset,
} from '@@/library/v4/components/OzContainedButton.vue'
import { useWhiteboardPlayModeStore } from '@@/pinia/whiteboard_play_mode'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfaceWhiteboardModeSwitcher',
  props: {
    backgroundLuminance: { default: 'dark' }
  },
  setup(__props: any) {



const whiteboardPlayModeStore = useWhiteboardPlayModeStore()

/** PLAY MODE */

function enterPlayMode(): void {
  whiteboardPlayModeStore.isPlayMode = true
  // Set search params
  const url = new URL(window.location.href)
  url.searchParams.set('play', 'true')
}
function exitPlayMode(): void {
  whiteboardPlayModeStore.isPlayMode = false
  // Clear search params
  const url = new URL(window.location.href)
  url.searchParams.delete('play')
}

return { __sfc: true,whiteboardPlayModeStore, enterPlayMode, exitPlayMode, OzContainedButton, OzContainedButtonColorScheme, OzContainedButtonSizePreset }
}

})